export default __webpack_public_path__ + "static/media/1.48f4509c.jpg";